import RecoverStep from "./recover_step";
import {getExposedMount} from "../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../utils/recover_consts";

const TEMPLATE = 'virtualization-setup';

export default class SetupLocalVm extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        const loadCapabilities = function () {
            const requestSettings = {
                aid: data.recovery.device.appliance_id,
                schedule_asid: data.recovery.device.asid
            };

            $.ajax({
                type: "POST",
                url: "/ra_ajax/capabilities",
                data: JSON.stringify(requestSettings),
                success: function (response) {
                    if (response.is_error) {
                        show_alert(response.title, response.message, {dialogClass: 'axDialog rstyled'});
                        fr.close();
                        return;
                    }

                    data.capabilities = response.data;
                    data.capabilities.vmMedian = data.capabilities.vmSizes[Math.round(data.capabilities.vmSizes.length / 2)];

                    if (data.capabilities.vmCpuRange) {
                        data.capabilities.cpuMedian = data.capabilities.vmCpuRange[Math.round(data.capabilities.vmCpuRange.length / 2)];
                    }

                    renderSetup();

                    $(el).find('.ram-slider span').not(':first,:last,[data-value=' + data.capabilities.vmMedian + ']').html('|');
                    $(el).find('.ram-slider span:first').addClass('selected');
                    $(el).find('.ram-slider span').css('width', ($(el).find('.ram-slider').width() - 18) / data.capabilities.vmSizes.length - 1);

                    if (data.capabilities.vmCpuRange) {
                        $(el).find('.cpu-slider span').not(':first,:last,[data-value=' + data.capabilities.cpuMedian + ']').html('|');
                        $(el).find('.cpu-slider span:first').addClass('selected');
                        $(el).find('.cpu-slider span').css('width', ($(el).find('.cpu-slider').width() - 18) / data.capabilities.vmCpuRange.length - 1);
                    }
                },
                dataType: AJAX_DATA_TYPE_JSON,
                contentType: "application/json"
            }).fail(fr.defaultAJAXErrorHandler);
        };
        data.render = {loadingComplete: false};
        data.tmp.previousStep = fr.currentStep;

        const renderSetup = function () {
            data.render.loadingComplete = true;
            fr.render('setupLocalVm');
        };

        const loadDevice = function () {
            const requestSettings = {
                filter: {machines: {id: data.deviceId}, jobs: {sva_job_status: "offline", appliance_online: 1}},
                startable: true
            };

            $.ajax({
                type: "POST",
                url: "/dashboardumc/inventory_data/" + data.clientId + "/VIRTUALIZED",
                data: JSON.stringify(requestSettings),
                success: function (response) {
                    if (response.data.length === 1) {
                        data.recovery.device = response.data[0].rowAttr;
                        loadCapabilities();
                    } else if (response.errors) {
                        data.render = response.errors;
                        fr.goTo('notAvailable');
                    } else {
                        fr.goTo('showVMExist');
                    }
                },
                dataType: AJAX_DATA_TYPE_JSON,
                contentType: "application/json"
            }).fail(fr.defaultAJAXErrorHandler);
        };


        // check for exposed mounts
        getExposedMount(data, function (response) {
            if (response.is_error == 0) {
                if (response.data.is_disk_exposed) {
                    data.share_id = response.data.share_id;
                    fr.goTo('revokeMount');
                } else {
                    loadDevice();
                    fr.render('setupLocalVm');
                }
            } else {
                console.log('getExposedMount: unexpected error');
            }
        });
    }


    postRender(data, el, fr) {
        if (data.render.loadingComplete) {
            if (data.capabilities.warning) {
                document.querySelector('.js-warn-block').classList.remove('infobox--hidden');
                document.querySelector('.js-warn-field').innerHTML = data.capabilities.warning['message'];
            }
            $('.ram-slider').slider({
                min: data.capabilities.minVMMemMb,
                max: data.capabilities.vmSizes.pop(),
                slide: function (event, ui) {
                    $('.ram-value').html(getHumanSize(ui.value * 1024 * 1024)); // convert to bytes
                }
            });

            let items = $('.recovery-ram .map span');
            let s = 4, d = $('.ram-slider').width() / (items.length - 1);
            let pos = [0, Math.ceil((items.length - 1) / 2), items.length - 1];
            $.each(items, function (i) {
                if ($.inArray(i, pos) != -1) {
                    $(this).addClass('label').html(getHumanSize($(this).data('value') * 1024 * 1024));
                }

                $(this).css('left', s);
                s += d;
            });

            if (data.capabilities.vmCpuRange) {
                $('.cpu-slider').slider({
                    min: data.capabilities.vmCpuMin,
                    max: data.capabilities.vmCpuRange.pop(),
                    slide: function (event, ui) {
                        $('.cpu-value').html(ui.value + ' CPU'); // convert to bytes
                    }
                });

                items = $('.recovery-cpu .map span');
                s = 4;
                d = $('.cpu-slider').width() / (items.length - 1);
                pos = [0, Math.ceil((items.length - 1) / 2), items.length - 1];
                $.each(items, function (i) {
                    if ($.inArray(i, pos) != -1) {
                        $(this).addClass('label').html($(this).data('value'));
                    }

                    $(this).css('left', s);
                    s += d;
                });
            }

            // render the correct styles for initial checkbox states
            $('.toggle_checkbox').each(function () {
                emulateCheck(this.id);
            });
        }
        $('.toggle_checkbox').change(function () {
            emulateCheck(this.id);
        });

        $('#use_current_address').on('change', function () {
            $('#vnc_enabled').prop('disabled', function (idx, oldAttr) {
                return !oldAttr;
            }); // toggle attribute disabled
            $('#vnc_enabled').parent('.toggle').toggleClass('disabled'); // toggle class for display purposes

            $(el).find('[name=test_server_address]').prop('disabled', function (idx, oldAttr) {
                return !oldAttr;
            }); // toggle attribute disabled

            $('#current_ip_address').toggle();
            $('#test_ip_address').toggle().val('');

            if ($(this).is(':checked')) {
                $('#vnc_enabled').prop('checked', true);
                $(el).find('[name=password]').prop('disabled', false);
                $('#test_ip_address').valid();
            }
            emulateCheck('vnc_enabled');
        });

        $('#vnc_enabled').on('change', function () {
            const passwd = $(el).find('[name=password]');

            if ($(this).is(':checked')) {
                passwd.prop('disabled', false);
            } else {
                passwd.prop('disabled', true).val('').valid();
            }
        });

        if (!data.recovery.virtualization.isTest) {
            $('#current_ip_address').show();
        }

        if (data.render.loadingComplete) {
            $('#vm_config_form').on('mouseup', 'label.error', function () {
                $(this).prev().focus();
            });

            $('#vm_config_form').on('keyup', '#vnc_password, #test_ip_address', function (e) {
                if ($(this).valid()) {
                    $('#vm_config_form .warntip').remove(); // remove warntip(s)
                }
            });

            $('#vm_config_form').on('mouseout', '#vnc_password, #test_ip_address', function (e) {
                $('#vm_config_form .warntip').remove(); // remove warntip(s)
            });

            $('#vm_config_form').on('mouseover', 'input.error', function (e) {
                const obj = $('.warntip').clone();
                const t_body = $(obj).find('.tooltip_body');
                const type = $(this).data('type');

                // set proper message
                if (type === 'ip-address') {
                    $(t_body).html(wrong_ip_address);
                } else if (type === 'password') {
                    $(t_body).html(wrong_password);
                }

                // insert current tooltip near focused field
                $(obj).insertBefore(this);
                $(obj).show();

                // set corrected position value according to tooltip size
                const h = $(t_body).outerHeight();
                $(obj).css({marginTop: -(h / 2)});
                $(obj).find('.triangle').css({top: h / 2 - 8});
            });

            $.validator.addMethod('ipv4', function (value) {
                const ipv4 = /^((([01]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))[.]){3}(([0-1]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))$/;
                return $('#use_current_address:checked').length || value.match(ipv4);
            }, '<i class="fa fa-exclamation-circle error"></i>');

            $.validator.addMethod('vncPassword', function (value) {
                return $('#vnc_enabled:not(:checked)').length || (value && value.trim() !== "");
            }, '<i class="fa fa-exclamation-circle error"></i>');

            $("#vm_config_form").validate();
            if (data.recovery.virtualization.isTest) {
                $("#test_ip_address").rules("add", {ipv4: true});
            }

            $("#vnc_password").rules("add", {vncPassword: true});
        }
    }

    transitionBack(data, el, fr) {
        if (data.useBrowse) {
            fr.goTo('browseLocalVms');
        } else {
            fr.goTo('setVirtualizationType');
        }
    }

    transitionStartVm(data, el, fr) {
    	var $modalError = $('.modal-box__error');
        if ($('#vm_config_form').valid()) {
            $modalError.hide();

            let vmCpus = 1; // default value for number of CPUs
            if (data.capabilities.vmCpuRange) {
                vmCpus = $('.cpu-slider').slider('value');
            }

            data.recovery.config = {
                sid: data.recovery.device.sid,
                restorePointsMillis: $('[name=restore_point]').val(),
                vmSizeMb: $('.ram-slider').slider('value'),
                vmCpus: vmCpus,
                useVNC: $('#vnc_enabled:checked').length,
                vncPasswd: $('[name=password]').val(),
                testIpAddress: $('#test_ip_address').val(),
                useCurrentAddress: $('#use_current_address:checked').length,
                isTest: data.recovery.virtualization.isTest
            };

            fr.goTo('startVm');
        } else {
					$modalError.show();
        }

    }

}
